module.exports = __webpack_public_path__ + "img/hair-color-2@2x.97591474.jpg";